module.exports = __webpack_public_path__ + "img/CardNFT04.ac69118e.png";